<template>
  <div class="bridge-call">
    <OTitle>Bridge Call</OTitle>
    <CShareThisFollow/>
    <o-j-l-links></o-j-l-links>
    <CFormFreeCall @success="onSuccess"></CFormFreeCall>
    <CAdLinkdial/>
    <o-j-l-links></o-j-l-links>
    <CShareThisInline/>
    <CFAQ></CFAQ>
    <CAdLinkdial/>
  </div>
</template>

<script>
import CFormFreeCall from '../forms/CFormFreeCall'
import OJLLinks from '../objects/OJLLinks'
import CFAQ from '../components/CFAQ'
import CShareThisInline from '../components/CShareThisInline'
import CShareThisFollow from '../components/CShareThisFollow'
import CAdLinkdial from '@/components/CAdLinkdial.vue'
import OTitle from '@/objects/OTitle.vue'

export default {
  name: 'PageFreeCall',
  components: { OTitle, CAdLinkdial, CFAQ, OJLLinks, CFormFreeCall, CShareThisInline, CShareThisFollow },
  metaInfo: {
    title: 'Spoof Call And Caller ID Faker. Free Spoof Call To Try Now.',
    meta: [
      {
        name: 'description',
        content: 'Spoof Call to change your CALLER ID when calling. Add voice changer for ultimate privacy. ' +
            'Try our free spoof call on this page to protect your personal information when on the phone.'
      },
      {
        name: 'keywords',
        content: 'second number,caller id, private calling'
      }
    ]
  },
  methods: {
    onSuccess ({ message }) {
      this.$router.push({ name: 'register', state: { callout: message } })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    flex-grow: 1;
  }
}

.c_follow {
  margin-bottom: 1rem;
}
</style>
